// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteWarehouseLocationMutation(
    $input: DeleteWarehouseLocationInput!
  ) {
    deleteWarehouseLocation(input: $input) {
      warehouseLocationEdge {
        cursor
        node {
          id
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      updater: store => {
        const deletedEdge = store
          .getRootField('deleteWarehouseLocation')
          .getLinkedRecord('warehouseLocationEdge')
          .getLinkedRecord('node');
        const deletedId = deletedEdge.getValue('id');

        const root = store.getRoot();
        const conn = ConnectionHandler.getConnection(
          root,
          'PaginatedWarehouseLocationsContainer_warehouseLocations',
        );

        if (conn) {
          ConnectionHandler.deleteNode(conn, deletedId);
        }
      },
    });
  },
};
